/* eslint-disable react/jsx-filename-extension */
import { assertNever, } from '@fluentui/react';
import React, { FC } from 'react';

export enum IconName {
  Empty = "Empty",
  /**
   * six points, 3*2 matrix
   */
  GripperDotsVertical = "GripperDotsVertical",
  /**
   * `=`
   */
  GripperBarHorizontal = "GripperBarHorizontal",
}

interface IconProps {
  name: string;
}

const Icon: FC<IconProps> = (props) => {
  const { name } = props;
  return (
    <span className="icon-container">
      <span className={`iconba iconba-${name}`} />
    </span>
  );
}

export interface ItemRowProps<T> {
  text: string;
  iconName: IconName;
  isOperationEnabled: boolean;
  operationText: string;
  onOperationTrigger?: (data?: T) => void;
  data?: T;
  // eslint-disable-next-line react/no-unused-prop-types
  index: number;
  rootRef?: React.Ref<HTMLDivElement>;
  className?: string;
}

export const ItemRow = <T extends unknown>(props: ItemRowProps<T>) => {
  const {
    rootRef,
    data,
    className,
    iconName,
    isOperationEnabled,
    onOperationTrigger,
    operationText,
    text,
  } = props;

  const onKeyDown: React.KeyboardEventHandler<HTMLSpanElement> = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      isOperationEnabled && onOperationTrigger?.(data);
    }
  }

  return (
    // `tabindex` is not controlled by row itself, but `GroupedList`(in fact, `FocusZone`, which asks for "data-is-focusable")
    // This is a quirk of Fluent-ui
    <div ref={rootRef} className={`item-row ${className ?? ''}`} tabIndex={0} data-is-focusable="true" role="row" key={text}>
      <Icon name={getClassNameByIconName(iconName)} />
      <span className="cell text-cell" role="cell">
        <span className="text" title={text}>{text}</span>
      </span>
      <span className="cell operation-cell" role="cell">
        <span
          aria-disabled={!isOperationEnabled}
          className={`operation ${isOperationEnabled ? "enabled" : "disabled"}`}
          tabIndex={isOperationEnabled ? 0 : undefined}
          role="button"
          onClick={() => { isOperationEnabled && onOperationTrigger?.(data) }}
          onKeyDown={onKeyDown}
        >
          {operationText}
        </span>
      </span>
    </div >
  );


  // eslint-disable-next-line consistent-return, @typescript-eslint/no-shadow
  function getClassNameByIconName(iconName: IconName) {
    switch (iconName) {
      case IconName.GripperBarHorizontal:
        return "GripperBarHorizontal";
      case IconName.GripperDotsVertical:
        return "GripperDotsVertical";
      case IconName.Empty:
        return "";
      default:
        assertNever(iconName);
    }
  }
}
